import { schema } from 'normalizr';
import { EmptyObject } from '../../../Resources/EmptyDefaults';

export const BOOK_DEMO_ACTIONS = 'bookDemoActions';

export const bookDemoSchema = new schema.Entity(BOOK_DEMO_ACTIONS, EmptyObject, { idAttribute: () => 'data' });
